<template>
  <Modal :model-value="modelValue" content-class="md:w-100" @update:model-value="$emit('update:modelValue', false)">
    <div class="bg-blue px-4 pb-5 pt-6 text-center text-white">
      <h2 class="font-bw-gradual text-2rem font-bold">
        Share
      </h2>
    </div>
    <div class="bg-white p-12">
      <ShareNetwork
        class="mb-5 flex items-center border-b border-gray-5 px-1 pb-5"
        network="facebook"
        :url="url"
        :title="title"
        :description="description"
        @click.prevent
      >
        <div class="mr-10">
          <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M43 37.625C43 40.5812 40.5812 43 37.625 43H5.375C2.41875 43 0 40.5812 0 37.625V5.375C0 2.41875 2.41875 0 5.375 0H37.625C40.5812 0 43 2.41875 43 5.375V37.625Z"
              fill="#797979"
            />
            <path
              d="M23.1384 43V26.2663H17.1654V20.299H23.1397V14.791C23.1397 9.23559 26.4198 5.96289 31.3749 5.96289C33.7493 5.96289 35.6863 6.21686 36.2813 6.2958V12.5352L32.2923 12.5335C29.5974 12.5335 29.0932 13.8702 29.0932 15.7491V20.299H35.9987L35.0232 26.2663H29.0932V43H23.1384Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="text-xl text-slate">
          Facebook
        </div>
      </ShareNetwork>
      <ShareNetwork
        class="mb-5 flex items-center border-b border-gray-5 px-1 pb-5"
        network="twitter"
        :url="url"
        :title="title"
        :description="description"
        @click.prevent
      >
        <div class="mr-10">
          <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M43 37.625C43 40.5812 40.5812 43 37.625 43H5.375C2.41875 43 0 40.5812 0 37.625V5.375C0 2.41875 2.41875 0 5.375 0H37.625C40.5812 0 43 2.41875 43 5.375V37.625Z"
              fill="#797979"
            />
            <path
              d="M35.946 13.6888C34.9184 14.1451 33.8133 14.4531 32.6529 14.5913C33.8371 13.8818 34.7453 12.7586 35.1737 11.4195C34.066 12.0765 32.8384 12.5538 31.5329 12.8107C30.4872 11.6964 28.9972 11 27.3484 11C24.1814 11 21.6146 13.5668 21.6146 16.7329C21.6146 17.1825 21.6654 17.6195 21.7632 18.0396C16.9977 17.8005 12.7735 15.5179 9.94599 12.0495C9.45251 12.8958 9.16956 13.8812 9.16956 14.9317C9.16956 16.9205 10.1819 18.6757 11.7202 19.7036C10.7805 19.6738 9.89582 19.4156 9.1232 18.9859C9.12256 19.0101 9.12257 19.0342 9.12257 19.0583C9.12257 21.837 11.0987 24.1526 13.7214 24.68C13.24 24.8109 12.7338 24.8811 12.2111 24.8811C11.8415 24.8811 11.4823 24.8449 11.1324 24.7779C11.8621 27.0557 13.9796 28.7143 16.488 28.7597C14.5261 30.2967 12.0539 31.2132 9.36772 31.2132C8.90472 31.2132 8.44839 31.1871 8 31.1331C10.537 32.76 13.5512 33.7091 16.7887 33.7091C27.3338 33.7091 33.1007 24.9728 33.1007 17.3969C33.1007 17.1485 33.094 16.9008 33.0832 16.6554C34.2058 15.8481 35.1772 14.8383 35.946 13.6888Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="text-xl text-slate">
          Twitter
        </div>
      </ShareNetwork>
      <ShareNetwork
        class="mb-5 flex items-center border-b border-gray-5 px-1 pb-5"
        network="email"
        :url="url"
        :title="title"
        :description="description"
        @click.prevent
      >
        <div class="mr-10">
          <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect fill="#797979" rx="5" height="43" width="43" />
            <path
              fill="white"
              d="m21.5,22.213l-11.985,-9.713l23.971,0l-11.986,9.713zm-5.425,-1.822l-6.575,-5.329l0,12.501l6.575,-7.172zm10.85,0l6.575,7.172l0,-12.501l-6.575,5.329zm-1.557,1.261l-3.868,3.135l-3.868,-3.135l-8.11,8.848l23.956,0l-8.11,-8.848z"
            />
          </svg>
        </div>
        <div class="text-xl text-slate">
          Email
        </div>
      </ShareNetwork>
      <a role="button" class="flex items-center px-1" @click="copyLink">
        <div class="mr-10">
          <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="43" height="43" rx="5" fill="#797979" />
            <path
              fill="white"
              d="m31.5,15.5l0,16l-16,0l0,-16l16,0zm2,-2l-20,0l0,20l20,0l0,-20zm-24,17l0,-21l21,0l0,2l-19,0l0,19l-2,0z"
            />
          </svg>
        </div>
        <div class="text-xl text-slate">
          Copy link
        </div>
      </a>
    </div>
  </Modal>
</template>

<script>
import { ShareNetwork } from 'vue-social-sharing/src/vue-social-sharing'
import Modal from '~/components/shared/Modal'

export default {
  components: { Modal, ShareNetwork },

  props: {
    modelValue: Boolean,
  },

  emits: ['update:modelValue'],

  computed: {
    url () {
      return window.location.href
    },

    title () {
      return window.document.title
    },

    description () {
      return window.document.querySelector('meta[name="description"]')?.content
    },
  },

  watch: {
    value (value) {
      if (value) {
        document.body.style.width = `${document.body.clientWidth}px`
      } else {
        document.body.style.removeProperty('width')
      }
    },
  },

  methods: {
    copyLink () {
      if (! navigator.clipboard) {
        return
      }
      navigator.clipboard.writeText(this.url).then(() => {
        alert('Url was copied to clipboard.')
      }, () => {
        alert('Can\'t copy to clipboard.')
      })
    },
  },
}
</script>

<style lang="scss" scoped>
:deep() {
  .modal-close-button path {
    fill: #fff !important;
  }
}
</style>
